var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDctr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.539 16.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -130)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1261.772 -657.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.342 787.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1286.8,795.019a.529.529,0,0,1-.529-.529v-4.462l-.584-.029a1.652,1.652,0,0,1-1.644-1.639.529.529,0,0,1,.525-.532h0a.529.529,0,0,1,.529.525.592.592,0,0,0,.589.588h.553a1.074,1.074,0,0,1,1.085,1.115v4.432A.528.528,0,0,1,1286.8,795.019Z",
    transform: "translate(-1284.04 -787.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1278.772 793.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1283.224,798.581h-.028a4.406,4.406,0,0,1-4.425-4.431.53.53,0,0,1,.529-.525h0a.528.528,0,0,1,.525.532,3.35,3.35,0,0,0,3.325,3.367h.022a3.36,3.36,0,0,0,3.394-3.325.552.552,0,0,1,.529-.551h0a.507.507,0,0,1,.526.5A4.42,4.42,0,0,1,1283.224,798.581Z",
    transform: "translate(-1278.772 -793.625)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1278.772 787.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1279.3,795.019a.529.529,0,0,1-.529-.529v-4.462a1.1,1.1,0,0,1,.351-.816,1.024,1.024,0,0,1,.764-.267h.528a.589.589,0,0,0,.585-.587.529.529,0,0,1,.529-.528h0a.529.529,0,0,1,.528.53,1.648,1.648,0,0,1-1.64,1.642h-.559l-.029,4.489A.528.528,0,0,1,1279.3,795.019Z",
    transform: "translate(-1278.772 -787.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1288.798 789.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1291.011,794.922a2.756,2.756,0,1,1,2.757-2.756A2.76,2.76,0,0,1,1291.011,794.922Zm0-4.455a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,1291.011,790.467Z",
    transform: "translate(-1288.255 -789.41)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1291.022 791.736)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1290.888,792.577a.646.646,0,0,1-.2-.043.459.459,0,0,1-.169-.115.5.5,0,0,1-.16-.37.53.53,0,0,1,.9-.381.518.518,0,0,1,.157.381.5.5,0,0,1-.157.37.476.476,0,0,1-.169.115A.594.594,0,0,1,1290.888,792.577Z",
    transform: "translate(-1290.359 -791.524)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1282.671 793.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M1287.17,803.594a4.76,4.76,0,0,1-4.71-4.7v-.838a.529.529,0,1,1,1.057,0v.835a3.647,3.647,0,1,0,7.295,0v-4.73a.529.529,0,0,1,1.057,0v4.734A4.757,4.757,0,0,1,1287.17,803.594Z",
    transform: "translate(-1282.46 -793.625)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDctr);
export default __webpack_public_path__ + "static/media/dctr.2d86e6ed.svg";
export { ForwardRef as ReactComponent };